import {useRecoilValue} from 'recoil';
import {userState} from '../../../../../recoil/user/userAtom';
import StripeHomeownerCustomerAccount from './StripeHomeownerCustomerAccount';
import StripeContractorConnectAccount from './StripeContractorConnectAccount';

export default function StripeAccountSettings() {
  const user = useRecoilValue(userState);

  if (!user) {
    return null;
  } else if (user.userType === 'REQUESTER') {
    return <StripeHomeownerCustomerAccount />;
  } else {
    return <StripeContractorConnectAccount />;
  }
}
